import FormInput from './Components/FormInput'

const ready = (callback) => {
  if (document.readyState !== 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}

ready(() => {
  const formInput = new FormInput()
  formInput.init()
})
